import { useFormat } from '@ideavivat/vivat-2';

const NOW = useFormat.date().computerShortDate();

export default function useInvoiceStatus() {
  const DEFAULT_INVOICE = {
    id: -1,
    code: '0000',
    name: '',
    date: NOW,
    dueDate: NOW,
    type: '',
    remarks: '',
    status: '',
    companyId: '',
    discount: 0,
    realDeliveryFee: 0,
    debtor: {
      id: -1,
      code: '',
      address: {
        province: { id: -1, nameInThai: '' },
        district: { id: -1, nameInThai: '' },
        subdistrict: { id: -1, nameInThai: '' },
      },
    },
  };

  const english = [
    'UNPAID',
    'PAID',
  ];

  const thai = [
    'ยังไม่ชำระเงิน',
    'ชำระเงินแล้ว',
  ];

  const translate = (status: string) => thai[english.indexOf(status)];

  const invoiceStatusClassMap = (status: string) => {
    switch (status) {
      case 'UNPAID':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-red-500';
      case 'PAID':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-green-500';
      default: return '';
    }
  };

  return {
    english,
    thai,
    translate,
    invoiceStatusClassMap,
    DEFAULT_INVOICE,
  };
}
